import { createSlice, current } from '@reduxjs/toolkit';
import {
	getInspectionAuthorityList,
	getInspectionAuthority,
	addNewInspectionAuthority,
	updateInspectionAuthority,
	deleteInspectionAuthority,
	checkInspectionAuthorityExists,
} from './thunk';

export const initialState = {
	itemInspectionAuthorityList: [],
	itemInspectionAuthority: null,
	isInspectionAuthorityLoading: false,
	isInspectionAuthoritySuccess: false,
	inspectionAuthorityList: [],
	inspectionAuthorityListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	exists: false,
};

const InspectionAuthoritySlice = createSlice({
	name: 'InspectionAuthority',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getInspectionAuthorityList.pending, state => {
			state.isLoadingList = true;
			state.isInspectionAuthoritySuccess = false;
		});

		builder.addCase(getInspectionAuthorityList.fulfilled, (state, action) => {
			const inspectionAuthorityList = action.payload || [];
			const inspectionAuthorityListSelect = [];

			inspectionAuthorityList.map(item =>
				inspectionAuthorityListSelect.push({
					item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemInspectionAuthorityList = inspectionAuthorityList;
			state.inspectionAuthorityList = inspectionAuthorityList;
			state.inspectionAuthorityListSelect = inspectionAuthorityListSelect;
			state.isLoadingList = false;
			state.isInspectionAuthoritySuccess = true;
		});

		builder.addCase(getInspectionAuthorityList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isInspectionAuthoritySuccess = false;
		});

		builder.addCase(getInspectionAuthority.pending, state => {
			state.isInspectionAuthorityLoading = true;
			state.isInspectionAuthoritySuccess = false;
		});

		builder.addCase(getInspectionAuthority.fulfilled, (state, action) => {
			state.itemInspectionAuthority = action.payload;
			state.isInspectionAuthorityLoading = false;
			state.isInspectionAuthoritySuccess = true;
		});

		builder.addCase(getInspectionAuthority.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isInspectionAuthorityLoading = false;
			state.isInspectionAuthoritySuccess = false;
		});

		builder.addCase(addNewInspectionAuthority.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewInspectionAuthority.fulfilled, (state, action) => {
			state.itemInspectionAuthorityList.push(action.payload);
			state.inspectionAuthorityList.push(action.payload);
			state.inspectionAuthorityListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewInspectionAuthority.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateInspectionAuthority.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateInspectionAuthority.fulfilled, (state, action) => {
			state.itemInspectionAuthorityList = state.itemInspectionAuthorityList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.inspectionAuthorityList = state.inspectionAuthorityList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.inspectionAuthorityListSelect =
				state.inspectionAuthorityListSelect.map(item =>
					item.value.toString() === action.payload._id.toString()
						? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
						}
						: item
				);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateInspectionAuthority.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteInspectionAuthority.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteInspectionAuthority.fulfilled, (state, action) => {
			state.itemInspectionAuthorityList = current(
				state.itemInspectionAuthorityList
			).filter(item => item._id !== action.payload._id);
			state.inspectionAuthorityList = current(state.inspectionAuthorityList).filter(
				item => item._id !== action.payload._id
			);
			state.inspectionAuthorityListSelect = current(
				state.inspectionAuthorityListSelect
			).filter(item => item.value !== action.payload._id);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteInspectionAuthority.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkInspectionAuthorityExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(
			checkInspectionAuthorityExists.fulfilled,
			(state, action) => {
				state.exists = action.payload.exists;
			}
		);

		builder.addCase(checkInspectionAuthorityExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = InspectionAuthoritySlice.actions;

export default InspectionAuthoritySlice.reducer;
